/**
 * Log errors using the logger
 */

/**
 * Format an error object for logging
 * @param {Error} error The error object
 * @param {String} customMessage Optional custom message to override error.message
 * @returns {Object} Formatted error object for logging
 */
export function formatErrorForLogging (error, customMessage) {
  if (error instanceof Error) {
    return {
      message: customMessage || error.message || 'Unknown error',
      error: error.message,
      stack: error.stack,
      name: error.name,
      code: error.code,
    }
  }

  // Fallback for non-Error objects
  const errorString = error ? String(error) : 'Unknown error'
  return {
    message: customMessage || errorString,
    error: errorString,
  }
}

/**
 * Log an error using the logger singleton
 * @param {Error} error The error
 * @param {String} message The error message
 */
export function log (error, message) {
  // Get logger dynamically to avoid circular dependency
  let logger
  try {
    // eslint-disable-next-line global-require
    const { getLogger } = require('./index')
    logger = getLogger()
  } catch (e) {
    // Fallback to console if logger is not available
    logger = console
  }

  if (!logger || !logger.error) {
    // eslint-disable-next-line no-console
    if (!console.error) {
      return null
    }
    logger = console
  }

  // Format the error properly for Winston
  if (error instanceof Error) {
    const errorMessage = message || error.message || 'Unknown error'
    return logger.error({
      message: errorMessage,
      error: error.message,
      stack: error.stack,
      name: error.name,
      code: error.code,
    })
  }

  // Fallback for non-Error objects
  return logger.error(error || 'Unknown error', message)
}

export default {
  log,
  formatErrorForLogging,
}
